import React, { useCallback } from 'react';

import styles from './ValidateLoginPage.module.css';
import hospitalLogo from './../../assets/common/logo-salut-parc-tauli-COLOR.svg';

import { getEnvironmentApiUrl } from '../../services/General';

import GeneralContext from '../../context/GeneralContext';

import { useEffect, useContext } from 'react';
import useHttp from '../../hooks/useHttp';

import ErrorSpinnerWrapper from '../../components/UI/ErrorSpinnerWrapper.tsx/ErrorSpinnerWrapper';

import { LoginRequest } from '../../interfaces/UserInfo';

import { useNavigate, useLocation } from 'react-router-dom';

const ValidateLoginPage: React.FC = () => {

    const {
        accessToken,
        setAccessToken,
        setHospitalToken
    } = useContext(GeneralContext);

    const navigate = useNavigate();
    const location = useLocation();

    const { isLoading, error, sendRequest: sendCredentials } = useHttp<LoginRequest>();

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const redirectTo = queryParams.get('redirectTo') ?? '/home/patients';

        if (!accessToken) return;
        navigate(redirectTo, { state: { token: accessToken } });
    }, [accessToken, navigate])

    const transformData = useCallback((request: LoginRequest) => {

        if (request.status_response.code === 200) {

            const hospitalData = {
                hospital_refresh_token: request.result.response.refreshToken,
            };

            localStorage.setItem('user', JSON.stringify(request.result.response?.user));
            localStorage.setItem('refresh-token', request.result.refresh_token);
            localStorage.setItem('refresh-token-expiration-date', request.result.refresh_exp_time);
            localStorage.setItem('hospitalData', JSON.stringify(hospitalData));

            setAccessToken(request.result.token);
            setHospitalToken(request.result.response.token);

        }
    }, [setAccessToken, setHospitalToken]);

    useEffect(() => {

        if (window.config.THIRD_PARTY_LOGIN === false) {
            setAccessToken(location.state.token);
        }
        else {
            const queryParams = new URLSearchParams(window.location.search);
            const codeAuth = queryParams.get('code_auth');
            if (!codeAuth) return;
            sendCredentials({
                url: getEnvironmentApiUrl() + 'login/keycloak/' + codeAuth,
                headers: { 'Content-Type': 'application/json', api_key: 'digitomedica' },
                method: 'GET',
            }, transformData);
        }
    }, [location.state.token, sendCredentials, setAccessToken, transformData]);

    useEffect(() => {
        if (!error) return;
        window.location.href = window.config.HOSPITAL_LOGIN_URL || '/logout';
    }, [error]);

    return (
        <div className={styles.validateLoginContainer}>
            <div className={styles.logoContainer}>
                <img
                    src={hospitalLogo}
                    alt='logo hospital'
                />
                <ErrorSpinnerWrapper
                    loading={isLoading}
                    error={error}
                ></ErrorSpinnerWrapper>
            </div>
        </div>
    );
};

export default ValidateLoginPage;